import { WindowEventListenersEnum } from "@/constants/constants";
import { useClientTranslations } from "@/hooks/useClientTranslations";
import { useState } from "react";
import { useEffect } from "react";
import { checkIsTruecallerLoginSupported } from "@/utils/common.helpers";
import { useSettingsCopies } from "@/context/StringsProvider";
import { Box } from "../Box";
import { Row } from "../Stack";
import { Divider } from "../Divider";
import { Text } from "../Text";
import { Button } from "../Button";
import { Img } from "../Img";

export const LoginWith = () => {
  const { t } = useClientTranslations();
  const { settingsCopies } = useSettingsCopies();
  const loginWithTruecaller = () => {
    const event = new CustomEvent(
      WindowEventListenersEnum.INIT_TRUECALLER_LOGIN,
    );
    window.dispatchEvent(event);
  };

  const [isTruecallerLoginSupported, setIsTruecallerLoginSupported] =
    useState(false);

  useEffect(() => {
    const isTruecallerLoginSupported = checkIsTruecallerLoginSupported();
    setIsTruecallerLoginSupported(isTruecallerLoginSupported);
  }, []);
  if (!isTruecallerLoginSupported) {
    return null;
  }
  return (
    <Box width={"w-full"} paddingHorizontal={8}>
      <Row fullWidth wrap={false} align="center" gap={2}>
        <Divider hasMargin={false} className="flex-1" bgColorType="light" />
        <Row justify="center" align="center" gap={1}>
          <Text size={2}>{t("auth_screen.login_with")}</Text>
          {settingsCopies?.truecallerIcon && (
            <Button
              noBg
              icon={
                <Img
                  src={`${process.env.NEXT_PUBLIC_CDN_ROOT_URL}${settingsCopies.truecallerIcon}`}
                  alt="Truecaller"
                  width={96}
                  height={20}
                  priority={true}
                />
              }
              onClick={loginWithTruecaller}
            />
          )}
        </Row>
        <Divider hasMargin={false} className="flex-1" bgColorType="light" />
      </Row>
    </Box>
  );
};
